import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import Loader from '../../../components/Common/Loader/Loader';
import EditUserForm from '../../../components/SiteAdmin/EditUserForm/EditUserForm';
import NotFound from '../../../components/NotFound/NotFound';
import { censorEmail, decode, censorPhone, censorWord } from '../../../helpers/queryEncryption';
import { demoRestrictionEncode } from '../../../actions/demoRestriction';
import getUser from './getUser.graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

export class EditUser extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
    };

    static defaultProps = {
        data: {
            loading: true
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            isRestrict: false,
        };
    }

    async componentDidMount() {
        const { demoRestrictionEncode } = this.props;
        const isRestrict = await demoRestrictionEncode({});
        this.setState({ isRestrict });
    }

    render() {
        const { data: { loading, getUser } } = this.props;
        const { formatMessage } = this.props.intl;
        const { isRestrict } = this.state;

        let initialValues = {};

        if (!loading && getUser && getUser?.status === 200) {
            initialValues = {
                id: getUser?.result?.id,
                firstName: isRestrict ? censorWord(decode(getUser?.result?.profile?.encryptFirstName)) :decode(getUser?.result?.profile?.encryptFirstName),
                lastName: isRestrict ? censorWord(decode(getUser?.result?.profile?.encryptLastName)) :decode(getUser?.result?.profile?.encryptLastName),
                phoneDialCode: getUser?.result?.phoneDialCode,
                email: isRestrict ? censorEmail(decode(getUser?.result?.encryptEmail)) : decode(getUser?.result?.encryptEmail),
                phoneNumber: isRestrict ? censorPhone(decode(getUser?.result?.encryptPhoneNumber)) : decode(getUser?.result?.encryptPhoneNumber),
                userStatus: getUser?.result?.userStatus,
                isBan: getUser?.result?.isBan,
                country: getUser?.result?.profile?.country,
                phoneCountryCode: getUser?.result?.phoneCountryCode,
                picture: getUser?.result?.profile?.picture,
                preferredCurrency: getUser?.result?.profile?.preferredCurrency,
                isRestrict
            }
        }

        if (!loading && !getUser?.result?.id) {
            return <NotFound title={formatMessage(messages.pageNotFound)} />;
        } else {
            return (
                <Loader type={"page"} show={loading}>
                    {!loading && <EditUserForm initialValues={initialValues} />}
                </Loader>
            )
        }
    }
}

const mapState = state => ({});

const mapDispatch = {
    demoRestrictionEncode
};

export default compose(
    connect(mapState, mapDispatch),
    injectIntl,
    withQuery(getUser, {
        options: (props) => ({
            variables: {
                id: Number(props.id),
                userType: 1
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }))(EditUser);